import * as React from 'react'
import MaskedInput from 'react-text-mask'

import { CalendarIcon } from '../../../images/icons/Calendar/Calendar'

import './styles.css'

export class DateInput extends React.Component<any, any> {
    render() {
        const {
            placeholder,
            guide,
            value,
            onChange,
            showIcon = true,
        } = this.props

        return (
            <div className="date-input-wrapper">
                <div>
                    <MaskedInput
                        mask={[/[0-3]/, /\d/, '/', /[0-1]/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]}
                        className="date-input-wrapper__input"
                        placeholder={placeholder}
                        guide={guide}
                        onChange={(e) => onChange(e.target.value)}
                        value={value}
                    />
                    {showIcon &&
                        <div className="date-input-wrapper__icon">
                            <CalendarIcon />
                        </div>
                    }
                </div>
            </div>
        )
    }
}

export default DateInput



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/common/DateInput/index.tsx